module.exports = __webpack_public_path__ + "static/Cloverly-3bb14e4f98c2997451076eaa242892b9.jpg";